import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getDevicesDetail } from '@blade-sxp/account/api/log';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
let default_1 = class default_1 extends Vue {
    keyword;
    end_time;
    start_time;
    fullSkDialogVisible = false;
    fileName = '';
    data = [];
    log_name = '';
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    loading = false;
    logLoginList = [];
    handleSizeChange(val) {
        this.pagination.size = val;
        this.getList();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.getList();
    }
    showSecondary(fileName) {
        this.fileName = fileName;
        this.fullSkDialogVisible = true;
    }
    /**
     *@Description: 登录日志列表
     *@Date: 2020-09-07 15:54:36
     */
    getList(search = false) {
        this.loading = true;
        let param = {
            end_time: String(this.end_time),
            keyword: String(this.keyword),
            log_name: '',
            order: 1,
            page: search ? 1 : this.pagination.page,
            pageSize: this.pagination.size,
            start_time: String(this.start_time),
        };
        getDevicesDetail(param)
            .then((resp) => {
            if (resp.data.data.list.length > 0) {
                this.data = resp.data.data.list;
            }
            else {
                this.data = [];
                if (resp.data.data.totalPage > 1) {
                    this.pagination.page = resp.data.data.totalPage;
                    this.getList();
                }
            }
            this.pagination.total = resp.data.data.total;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    handleExport() {
        window.location.href = process.env.NODE_ENV === 'development' ? `${this.fileName}` : this.fileName;
    }
    mounted() {
        this.getList();
    }
};
__decorate([
    Prop()
], default_1.prototype, "keyword", void 0);
__decorate([
    Prop()
], default_1.prototype, "end_time", void 0);
__decorate([
    Prop()
], default_1.prototype, "start_time", void 0);
default_1 = __decorate([
    Component({
        name: 'deviceManagement',
        components: {
            SecondaryVerification,
        },
        i18n: {
            messages: {
                zh: {
                    login: '登入',
                    logout: '登出',
                    fileName: '文件名',
                    moduleName: '模块名称',
                    opName: '操作名称',
                    status: '状态',
                    userName: '用户名',
                    createTime: '创建时间',
                },
                'en-us': {
                    login: 'Login',
                    logout: 'Logout',
                    fileName: 'fileName',
                    moduleName: 'moduleName',
                    opName: 'opName',
                    status: 'status',
                    userName: 'userName',
                    createTime: 'createTime',
                },
            },
        },
    })
], default_1);
export default default_1;
